/* =====================================================
   TUNE MFD Build & Buy configurator
   ===================================================== */
(function () {
    'use strict';

    var root = document.querySelector('[data-buy-config]');
    if (!root) {
        return;
    }

    var SHOPIFY = window.TUNE_SHOPIFY || {};
    var CURRENCY = SHOPIFY.currency || 'AUD';
    var LOCALE = SHOPIFY.locale || document.documentElement.lang || 'en';
    var ORDER_NOTE = SHOPIFY.orderNote || '';
    var BASE_KEY = 'base';
    var BUNDLE_KEY = 'bundle';
    var INDIVIDUAL_KEYS = ['dashcam', 'front', 'rear'];

    var IMAGES = window.TUNE_BUY_IMAGES || {};

    var image = document.getElementById('buyShowcaseImage');
    var summary = root.querySelector('.buy_summary');
    var summaryList = root.querySelector('[data-buy-summary]');
    var totalEl = root.querySelector('[data-buy-total]');
    var noteEl = root.querySelector('[data-buy-note]');
    var checkoutBtn = root.querySelector('[data-buy-checkout]');
    var errorEl = root.querySelector('[data-buy-error]');
    var waitlistBtn = root.querySelector('.buy_waitlist');
    var secureEl = root.querySelector('[data-buy-secure]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('.buy_option_input[data-addon]'));

    var moneyFormatter;
    try {
        moneyFormatter = new Intl.NumberFormat(LOCALE, {
            style: 'currency',
            currency: CURRENCY,
            currencyDisplay: 'narrowSymbol'
        });
    } catch (err) {
        moneyFormatter = null;
    }

    function formatMoney(value) {
        if (moneyFormatter) {
            return moneyFormatter.format(value);
        }
        return '$' + value.toFixed(2);
    }

    function roundMoney(value) {
        return Math.round(value * 100) / 100;
    }

    function getInput(key) {
        return root.querySelector('.buy_option_input[data-addon="' + key + '"]');
    }

    function isSelectable(input) {
        return !!input && !input.disabled;
    }

    function getSelection() {
        var selected = {};
        inputs.forEach(function (input) {
            selected[input.getAttribute('data-addon')] = input.checked;
        });
        return selected;
    }

    function getCheckoutAddons(selected) {
        if (selected[BUNDLE_KEY]) {
            return [BUNDLE_KEY];
        }
        return INDIVIDUAL_KEYS.filter(function (key) {
            return selected[key];
        });
    }

    function getCheckoutKeys(selected) {
        var keys = [];
        if (selected[BASE_KEY]) {
            keys.push(BASE_KEY);
        }
        return keys.concat(getCheckoutAddons(selected));
    }

    function allIndividualsSelected() {
        return INDIVIDUAL_KEYS.every(function (key) {
            var input = getInput(key);
            return input && input.checked;
        });
    }

    function uncheckIndividuals() {
        INDIVIDUAL_KEYS.forEach(function (key) {
            var input = getInput(key);
            if (input) {
                input.checked = false;
            }
        });
    }

    function syncExclusiveSelection(changedInput) {
        var key = changedInput.getAttribute('data-addon');
        var bundleInput = getInput(BUNDLE_KEY);

        if (key === BUNDLE_KEY && changedInput.checked) {
            uncheckIndividuals();
            return;
        }

        if (INDIVIDUAL_KEYS.indexOf(key) === -1 || !changedInput.checked) {
            return;
        }

        // Picking all three cameras is the bundle, but only swap when the bundle can
        // actually be bought. Otherwise keep the three individual cameras.
        if (allIndividualsSelected() && isSelectable(bundleInput)) {
            uncheckIndividuals();
            bundleInput.checked = true;
            return;
        }

        if (bundleInput) {
            bundleInput.checked = false;
        }
    }

    function imageKey(selected) {
        var hasDashcam = selected.dashcam || selected[BUNDLE_KEY];
        var hasCameras = selected.front || selected.rear || selected[BUNDLE_KEY];

        if (hasDashcam && hasCameras) {
            return 'both';
        }
        if (hasDashcam) {
            return 'dashcam';
        }
        if (hasCameras) {
            return 'cameras';
        }
        return 'none';
    }

    function getSummaryRows(selected) {
        var rows = [];
        getCheckoutKeys(selected).forEach(function (key) {
            var input = getInput(key);
            if (!input) {
                return;
            }
            rows.push({
                label: input.getAttribute('data-label') || key,
                price: Number(input.getAttribute('data-price')) || 0
            });
        });
        return rows;
    }

    function getTotals(selected) {
        var rows = getSummaryRows(selected);
        var kitTotal = 0;
        var addonTotal = 0;

        rows.forEach(function (row) {
            kitTotal += row.price;
        });
        getCheckoutAddons(selected).forEach(function (key) {
            var input = getInput(key);
            if (input) {
                addonTotal += Number(input.getAttribute('data-price')) || 0;
            }
        });

        return {
            rows: rows,
            kitTotal: roundMoney(kitTotal),
            baseSelected: !!selected[BASE_KEY],
            addonTotal: roundMoney(addonTotal)
        };
    }

    function showError(message) {
        if (!errorEl) {
            return;
        }
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
    }

    function preload() {
        Object.keys(IMAGES).forEach(function (key) {
            if (IMAGES[key]) {
                var img = new Image();
                img.src = IMAGES[key];
            }
        });
    }

    function updateCheckoutState(selected) {
        if (!checkoutBtn) {
            return;
        }
        checkoutBtn.disabled = getCheckoutKeys(selected).length === 0;
        checkoutBtn.textContent = 'Buy now';
    }

    function updateOrderCopy(totals) {
        if (!noteEl) {
            return;
        }

        if (totals.baseSelected) {
            noteEl.textContent = ORDER_NOTE;
        } else if (totals.addonTotal > 0) {
            noteEl.textContent = 'Cameras ship on their own. Paid in full at checkout.';
        } else {
            noteEl.textContent = 'Select the TUNE MFD and/or cameras to continue.';
        }
    }

    function updateView() {
        var selected = getSelection();
        var imageId = imageKey(selected);
        var totals = getTotals(selected);

        if (image && IMAGES[imageId] && image.getAttribute('src') !== IMAGES[imageId]) {
            image.classList.add('is-swapping');
            window.setTimeout(function () {
                image.setAttribute('src', IMAGES[imageId]);
                image.removeAttribute('srcset');
                image.classList.remove('is-swapping');
            }, 160);
        }

        if (summaryList) {
            summaryList.innerHTML = '';
            if (!totals.rows.length) {
                var empty = document.createElement('li');
                empty.className = 'buy_summary_row buy_summary_row--empty';
                empty.textContent = 'No items selected';
                summaryList.appendChild(empty);
            } else {
                totals.rows.forEach(function (row) {
                    var li = document.createElement('li');
                    li.className = 'buy_summary_row';
                    var name = document.createElement('span');
                    name.textContent = row.label;
                    var price = document.createElement('span');
                    price.textContent = formatMoney(row.price);
                    li.appendChild(name);
                    li.appendChild(price);
                    summaryList.appendChild(li);
                });

                // Informational only: the bundle price already includes the saving.
                var bundleInput = getInput(BUNDLE_KEY);
                var saving = bundleInput ? Number(bundleInput.getAttribute('data-savings')) : 0;
                if (selected[BUNDLE_KEY] && saving > 0) {
                    var savingRow = document.createElement('li');
                    savingRow.className = 'buy_summary_row buy_summary_row--saving';
                    var savingLabel = document.createElement('span');
                    savingLabel.textContent = 'Bundle saving';
                    var savingValue = document.createElement('span');
                    savingValue.textContent = '−' + formatMoney(saving);
                    savingRow.appendChild(savingLabel);
                    savingRow.appendChild(savingValue);
                    summaryList.appendChild(savingRow);
                }
            }
        }

        if (totalEl) {
            totalEl.textContent = formatMoney(totals.kitTotal);
        }

        showError('');
        updateOrderCopy(totals);
        updateCheckoutState(selected);
    }

    function getVariantId(key) {
        var input = getInput(key);
        return input ? (input.getAttribute('data-variant') || '').trim() : '';
    }

    function isVariantConfigured(key) {
        return /^\d+$/.test(getVariantId(key));
    }

    function setCheckoutBusy(isBusy) {
        if (!checkoutBtn) {
            return;
        }
        checkoutBtn.disabled = isBusy;
        checkoutBtn.textContent = isBusy ? 'Redirecting…' : 'Buy now';
    }

    function readError(response) {
        return response.json().then(function (data) {
            return (data && (data.description || data.message)) || 'Something went wrong adding that to your cart.';
        }, function () {
            return 'Something went wrong adding that to your cart.';
        });
    }

    // The configurator owns its own products in the cart: any of them already there
    // are replaced by this selection, and anything else in the cart is left alone.
    function checkout(selected) {
        var configVariantIds = inputs.map(function (input) {
            return Number(input.getAttribute('data-variant'));
        }).filter(Boolean);

        var items = getCheckoutKeys(selected).map(function (key) {
            return { id: Number(getVariantId(key)), quantity: 1 };
        });

        setCheckoutBusy(true);
        showError('');

        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) {
                return response.json();
            })
            .then(function (cart) {
                var updates = {};
                var hasUpdates = false;
                (cart.items || []).forEach(function (item) {
                    if (configVariantIds.indexOf(item.variant_id) !== -1) {
                        updates[item.key] = 0;
                        hasUpdates = true;
                    }
                });
                if (!hasUpdates) {
                    return null;
                }
                return fetch('/cart/update.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ updates: updates })
                });
            })
            .then(function () {
                return fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ items: items })
                });
            })
            .then(function (response) {
                if (!response.ok) {
                    return readError(response).then(function (message) {
                        throw new Error(message);
                    });
                }
                window.location.href = '/checkout';
            })
            .catch(function (err) {
                setCheckoutBusy(false);
                updateCheckoutState(getSelection());
                showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
            });
    }

    function handleCheckout() {
        var selected = getSelection();
        var keys = getCheckoutKeys(selected);

        if (!keys.length) {
            showError('Select the TUNE MFD and/or at least one camera to continue.');
            return;
        }

        if (!keys.every(isVariantConfigured)) {
            showError('One of the selected items can’t be bought online yet. Please contact us to order it.');
            return;
        }

        checkout(selected);
    }

    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            syncExclusiveSelection(input);
            updateView();
        });
    });

    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', handleCheckout);
    }

    // When Shopify has nothing sellable, a dead "Buy now" is just noise, so the
    // waitlist becomes the primary action instead.
    function applySoldOutLayout() {
        var everythingSoldOut = inputs.length > 0 && inputs.every(function (input) {
            return input.disabled;
        });

        if (!everythingSoldOut) {
            return;
        }

        if (checkoutBtn) {
            checkoutBtn.hidden = true;
        }
        if (summary) {
            summary.hidden = true;
        }
        if (waitlistBtn) {
            waitlistBtn.classList.add('buy_waitlist--primary');
            waitlistBtn.textContent = 'Join the waitlist';
        }
        if (secureEl) {
            secureEl.textContent = 'Checkout reopens when the next batch lands.';
        }
    }

    preload();
    updateView();
    applySoldOutLayout();
}());
